import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title is-size-5" }
const _hoisted_2 = { class: "mb-2" }

import { computed, provide, onUnmounted } from "vue"
import { useStore } from "vuex"
import VirtualList from "vue3-virtual-scroll-list"
import BomCartSuggestion from "./BomCartSuggestion.vue"
import LoadingIcon from "@/components/common/LoadingIcon.vue"

const scroll = `
  max-height: 40vh;
  overflow-y: 'scroll';
  overflow-x: hidden;
`


export default /*#__PURE__*/_defineComponent({
  __name: 'BomCartSuggestions',
  setup(__props) {

const store = useStore()

const partSuggestionsWithQuantity = computed(() => {
  return store.getters["content/cartSuggestionsWithQuantity"]
})
const isLoading = computed(() => {
  return store.state.content.bom.cartSuggestions.isLoading
})
const isWidget = computed(() => {
  return store.getters["widgets/isWidget"]
})

provide(
  "partSuggestionQuantity", 
  { updatePartSuggestionQuantity }
)
function updatePartSuggestionQuantity(
  partId: number, 
  quantity: number
) {
  store.dispatch("content/updateCartSuggestionQuantity", {
    partId,
    quantity
  })
}

async function getMore() {
  await store.dispatch("content/getMoreCartSuggestions")
}

onUnmounted(() => {
  store.dispatch("content/clearCartSuggestions")
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$tc('suggestion', 2)), 1),
    (isLoading.value)
      ? (_openBlock(), _createBlock(LoadingIcon, {
          key: 0,
          style: {"height":"15vh","width":"100%"}
        }))
      : (_openBlock(), _createBlock(_unref(VirtualList), {
          key: 1,
          "data-sources": partSuggestionsWithQuantity.value,
          "data-component": BomCartSuggestion,
          "extra-props": { isWidget: isWidget.value },
          keeps: 200,
          style: scroll,
          "data-key": "id",
          ref: "virtualList",
          "wrap-class": "mt-4",
          onTobottom: getMore
        }, null, 8, ["data-sources", "extra-props"]))
  ]))
}
}

})